import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { GridFieldSummary } from '~/models/modules/gridField';

@Injectable({ providedIn: 'root' })

export class GridLayoutManagerService {
  public _gridColumnSubjects: { [page: string]: BehaviorSubject<GridFieldSummary[]> } = {};
  private _gridDataSubjects: { [page: string]: Subject<boolean> } = {};
  private _gridColumnSubjects2: BehaviorSubject<GridFieldSummary[]> = new BehaviorSubject<GridFieldSummary[]>(null);

  private customefeildclear: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private anybehaviorsubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);


  private _finishSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private finihsSubjectCurrentValue = false;
  public _editColumnsActive: boolean;
  public columnChangeSubscription: boolean = false;
  // ActivateOrDeactivate: EventEmitter<any> = new EventEmitter();
  public Set_editColumnsActive(value: boolean) {
    this._editColumnsActive = value;
  }

  constructor() { }

  setGridColumnSubjects(page: string, girdColumns: GridFieldSummary[]) {
    let gridColumnSubject = this._gridColumnSubjects[page];

    if (!gridColumnSubject) {
      gridColumnSubject = this._gridColumnSubjects[page] = new BehaviorSubject<GridFieldSummary[]>(null);
    }

    this._gridColumnSubjects[page].next(girdColumns);
  }

  subscribeToColumnsChanges2(): BehaviorSubject<GridFieldSummary[]> {
    return this._gridColumnSubjects2;
  }

  subscribeToCustomFeildClear(): BehaviorSubject<any> {
    return this.customefeildclear;
  }

  sendanybehaviorsubject(): BehaviorSubject<any> {
    return this.anybehaviorsubject;
  }

  subscribeToColumnsChanges(page: string, cb: (gridColumns: GridFieldSummary[]) => void) {
    let gridColumnSubject = this._gridColumnSubjects[page];

    if (!gridColumnSubject) {
      gridColumnSubject = this._gridColumnSubjects[page] = new BehaviorSubject<GridFieldSummary[]>(null);
    }

    let resualt = this._gridColumnSubjects[page].subscribe((gridColumns) => {
      cb(gridColumns);
    });

    return resualt;
  }

  setGridDataSubjects(page: string, IsReactivate: boolean = false) {
    let gridDataSubject = this._gridDataSubjects[page];

    if (!gridDataSubject) {
      gridDataSubject = this._gridDataSubjects[page] = new Subject<boolean>();
    }

    if (IsReactivate) {
      this._gridDataSubjects[page].next(false);
    }
    else {
      this._gridDataSubjects[page].next(true);
    }
  }

  subscribeToDataChanges(page: string, cb: (datachanged: boolean) => void) {
    let gridDataSubject = this._gridDataSubjects[page];

    if (!gridDataSubject) {
      gridDataSubject = this._gridDataSubjects[page] = new Subject<boolean>();
    }

    return this._gridDataSubjects[page].subscribe((x) => {
      cb(x);
    });
  }

  toggleFinishSubject() {
    this.finihsSubjectCurrentValue = !this.finihsSubjectCurrentValue;
    this._finishSubject.next(this.finihsSubjectCurrentValue);
  }

  getFinishSubject() {
    return this._finishSubject;
  }

  /**
   * Destroys cached/local data. To be called when the grid view is being destroyed.
   */
  destroy() {
    for (const key of Object.keys(this._gridColumnSubjects)) {
      //this._gridColumnSubjects[key].complete();
      //this._gridColumnSubjects[key] = new BehaviorSubject<GridFieldSummary[]>(null);
    }
    //this._gridColumnSubjects = {};

    for (const key of Object.keys(this._gridDataSubjects)) {
      this._gridDataSubjects[key].complete();
    }

    this._gridDataSubjects = {};
  }
}
